import {ChangeDetectorRef,Component} from '@angular/core';
import { IonicPage, NavController, MenuController, ModalController, AlertController, Events, Slides} from 'ionic-angular';
import {	TranslateService} from '@ngx-translate/core';
import {	LoginProvider} from '../../providers/login/login';
import {	SettingsProvider} from '../../providers/settings/settings';
import {	HomePage} from '../home/home';
import {	ComplaintTabsPage} from '../complaint-tabs/complaint-tabs';
import {	VisitorTabsPage} from '../visitor-tabs/visitor-tabs';
import {	BillingPaymentsPage} from '../billing-payments/billing-payments';
import {	MeterPage} from '../meter/meter';
import {	NoticesProvider} from '../../providers/notices/notices';
import {	StaffProvider} from '../../providers/staff/staff';
import {	ProfilePage} from '../profile/profile';
import {	MyStaffTabsPage} from '../my-staff-tabs/my-staff-tabs';
import {	NoticesPage} from '../notices/notices';
import {	MySocietyPage} from '../my-society/my-society';
import {	NoticeDetailsPage} from '../notice-details/notice-details';
import {	SettingsPage} from '../settings/settings';
import {	AppSearchPage} from '../app-search/app-search';
import {	PanicPage} from '../panic/panic';
import {	BillingPaymentsProvider} from '../../providers/billing-payments/billing-payments';
import {	ToastProvider} from '../../providers/toast/toast';
import {	NotificationsPage} from '../notifications/notifications';
import {	StaffDetailPage} from '../staff-detail/staff-detail';
import {	MembersPage} from '../members/members';
import {	MakePaymentPage} from '../make-payment/make-payment';
import {	PermissionCheckPipe} from '../../pipes/permission-check/permission-check'; 
import {	SurveyPage} from '../survey/survey';
import {	UtilService} from '../../services/util';
import {	environment} from '../../environments/environment';
import {	PassPurposePage} from '../pass-purpose/pass-purpose';
import {	AddComplaintsPage} from '../add-complaints/add-complaints';
import {	FacilitySelectLocationPage} from '../facility-select-location/facility-select-location';
import {	VisitorProvider} from '../../providers/visitor/visitor';
import {	MyVehiclePage} from '../my-vehicle/my-vehicle';
import {	IvrModalPage} from '../ivr-modal/ivr-modal';
import {	Storage} from '@ionic/storage';
import {	SettingService} from '../../services/setting-service';
import {	MobileAppService} from '../../services/mobile-app';
import {	SignUpProvider} from '../../providers/sign-up/sign-up';
import {	SignUpFormPage} from '../sign-up-form/sign-up-form';
import moment from 'moment';


//{{'HOME_AWAY' | translate}}


@IonicPage()
@Component({
	selector: 'page-dashboard',
	templateUrl: 'dashboard.html',
	providers: [PermissionCheckPipe]
})
export class DashboardPage {
	societyLogo = "";
	notices = [];
	impNotices = [];
	footer = [];
	staffs = [];
	flash: any;
	outstandings = [];
	allimages = [];
	showData = false;
	permissions: any;
	homeAway = false;
	animate = true;
	societySettings = {};
	meterUser: any;
	notifySurveyFlag: any;
	errorLogo: any;
	selRegistrationLogin: any;
	registrationStatus: any;
	adminRemarks: null;
	selfRegisterDetail: any;
	signupToken: any;
	newFeatureList = [];
	newCustomData : any;
	resident_dashboard:any;

	constructor(public navCtrl: NavController,
		// private storage : Storage,
		// public navParams: NavParams, 
		private loginProvider: LoginProvider,
		private SettingsProvider: SettingsProvider,
		private menu: MenuController,
		private noticeProvider: NoticesProvider,
		private staffProvider: StaffProvider,
		private bpProvider: BillingPaymentsProvider,
		public modalCtrl: ModalController,
		public toast: ToastProvider,
		private perPipe: PermissionCheckPipe,
		public events: Events,
		private signUpProvider: SignUpProvider,
		private util: UtilService,
		private visitorProvider: VisitorProvider,
		private SettingService: SettingService,
		private mobileApp: MobileAppService,
		private storage: Storage,
		private translate: TranslateService,
		private ref: ChangeDetectorRef,
		private alertCtrl : AlertController
		) {
			this.resident_dashboard={
				show_outstanding:true,
				show_icons:true,
				show_quick_icons:true,
				custom_icons:[],
				show_amenities: false,
				quick_icons_popup:{}

			  }
			this.getCovidList();
			// ref.detach();

			setInterval(() => {
				try{
					this.ref.detectChanges();
				}catch(e){}
			}, 500);
		this.errorLogo = util.onErrorLogo();

		this.selRegistrationLogin = localStorage.getItem('signup_login')

		if (this.selRegistrationLogin) {
			this.requestStatus()
			this.societyLogo = 'assets/images/logo/ism.png'
			this.showData = true;
			this.allimages.push('assets/images/background/p7.jpg');
			this.allimages.push('https://s3.amazonaws.com/ismdoc/society-images/66/image2.jpg');
		}


		this.notifySurveyFlag = localStorage.getItem('surveyFlag')
		// console.log(this.notifySurveyFlag, "notify")

		this.initMeterUser()
		this.menu.enable(true);

		events.subscribe('homeAwayUpdate', (val) => {
			this.homeAway = val;
		});

		events.subscribe('payment-browser:exit', (val) => {
			this.bpProvider.getOutstandings(0).then(val => {
				if (val.status == "success") {
					// this.outstandings = val.data;
					this.setOutstanding(val.data);
				}
			}).catch(err => {
				console.log(err);
			});
		});

		events.subscribe('user:created', (val) => {
			this.permissions = val.permissions;
		});


		setTimeout(() => {
			this.doRefresh();
		},1000)


		// this.translate.get('MENU_DSB').subscribe(translated => {
		//   console.log("Variable value ", translated);
		// });

	}
	initMeterUser() {
		this.loginProvider.getSocietySettings().then(val => {
			if(val){
				console.log(val)
				this.societySettings = val;
				if (this.societySettings && 'res_app_switch' in this.societySettings) {
					this.loginProvider.getMeterUser().then(val => {
						// console.log(val)
						if (val && val.status == "success" && val.data && val.data.user) {
							this.meterUser = val.data
						} else {
							console.log("initMeterUser Failed =>", val);
						}
					});
				}
			}
		});
	}

	doRefresh(refresher = null) {
		if (this.selRegistrationLogin == 'true') {
			console.log("hello true refresher")
			this.requestStatus()
			setTimeout(() => {
				this.showData = true;
				refresher.complete()
			}, 1000)
		} else {
			this.showData = false;
			this.storage.get("loginDetails").then((val) => {
				if(val){
					this.loginProvider.updateUserRegisterApp(val).then(val => {
						if (this.selRegistrationLogin == 'false' || this.selRegistrationLogin == undefined) {
							this.initializeDashboard(refresher);
						}
					});
				}
			});
		}
	}
	checkDashboardComp(mod,type){
		if(this.perPipe.transform(this.permissions,mod,type)){
			return true
		}
		else{
			return false
		}
	}
	setOutstanding(data) {
		this.outstandings = [];
		data.forEach(val => {
			// let conf = val.custom_bill_config;
			// if(conf && ('meter_app' in conf) && conf.meter_app == 1){

			// }
			this.outstandings.push(val);
		});
	}
	initializeDashboard(refresher = null) {
		if (!this.selRegistrationLogin || this.selRegistrationLogin == undefined) {
			console.log("come their")
			setTimeout(() => {
				this.initMeterUser()
				this.bpProvider.getOutstandings(1).then(val => {
					if (val.status == "success") {
						// this.outstandings = val.data;
						this.setOutstanding(val.data)
						this.bpProvider.getBillTypes(true).then(val => {
							this.showData = true;
							try {
								refresher ? refresher.complete() : console.log("refresher object not found !")
							} catch (error) {
								console.log(error);
							}
						});
					} else {
						this.showData = true;
						try {
							refresher.complete();
						} catch (error) {
							console.log(error);
						}
					}
				}).catch(val => {
					this.showData = true;
					try {
						refresher.complete();
					} catch (error) {
						console.log(error);
					}
				});
				this.noticeProvider.getNotices("TICKER").then(val => {
					console.log("getNotices=TICKER>", new Date());
					if (val.status == "success") {
						this.flash = val.data;
						console.log(this.flash)
					}
				});
			}, 2000)
			setTimeout(() => {
				this.noticeProvider.getSocietyImages().then(val => {
					if (val.status == "success") {
						this.allimages = [];
						if (val.data && val.data.length > 0) {
							this.allimages = val.data;
						} else {
							this.allimages.push('assets/images/background/p7.jpg');
						}
					}
				});
				this.loginProvider.getUserDetails().then(val => {
					let baseUrl = environment.ismBaseUrl;
					this.loginProvider.getSocietyLogo().then(logo => {
						if (logo) {
						  this.societyLogo = logo;
						} else {
						  this.societyLogo = ''; // Default or fallback value
						}
					  });
					
					
					this.permissions = val.permissions;
					if (val.home_away) {
						this.homeAway = true;
					}
				});
			}, 1000);
			setTimeout(() => {
				this.noticeProvider.getNotices("NOTICE").then(val => {
					if (val.status == "success") {
						this.notices = [];
						let read = 0;
						val.data.forEach(item => {
							if (item.category == "NOTICE" || item.category == "TICKER") {
								if (item.is_read == false) {
									this.notices.splice(read, 0, item);
									read++;
								} else {
									this.notices.push(item);
								}
							}
						});
					}
				});

				this.noticeProvider.getNotices("COMMON").then(val => {
					if (val.status == "success") {
						this.impNotices = val.data;
					}
				});

				this.noticeProvider.getNotices("FOOTER").then(val => {
					if (val.status == "success") {
						if (val.data.length != 0) {
							val.data.forEach(footer => {
								if (footer.file_urls) {
									try {
										let file_urls = JSON.parse(footer.file_urls);
										this.footer = [];
										file_urls.forEach(image => {
											this.footer.push(image);
										});
									} catch (error) {
										console.log(error);
									}
								}
							});
						}
					}
				});
			}, 3000);

			setTimeout(() => {
				this.staffProvider.getStaffs().then(val => {
					try {
						if (val.status == "success") {
							this.staffs = [];
							for (let i = 0; i < 3 && i < val.data.length; i++) {
								this.staffs.push(val.data[i]);
							}
							// console.log(this.staffs);
						}
					} catch (error) {
						console.log(error);
					}
				});
				this.visitorProvider.makecompanyNameMap();
				this.checkIvrConfig();
			}, 4000);
		}

		this.loginProvider.getSocietySettings().then(val => {
			console.log(val);
			// debugger
			if(val && val.society_data &&val['society_data'].data){
				this.storage.set('society_data',val.society_data)
			var d = val['society_data'].data;
				if(d && typeof d == 'string'){
				   var	data = JSON.parse(d)
					if(data.resident_dashboard){
						this.resident_dashboard = data.resident_dashboard
					}
				}
			}
		  });

		
	}

	slideOpts = {
		effect: 'flip'
	};

	// : "Staff",
	// : "Survey",
	// : "Family",
	// : "Notices",
	// "MENU.MY_SOCIETY": "My complex",
	// : "Settings",
	// "MENU.PANIC": "Panic",
	// : "More"

	items = [
		[{
			icon: "ios-card-outline",
			title: "MENU.ACCOUNT",
			page: BillingPaymentsPage,
			index: 0,
			mod: "BILL",
			type: "READ"
		},
		{
			icon: "ios-contacts-outline",
			title: "MENU.VISITOR",
			page: VisitorTabsPage,
			mod: "VMS",
			type: "READ"
		},
		{
			icon: "ios-speedometer-outline",
			title: "MENU.ENERGY",
			page: MeterPage,
			mod: "MTR",
			type: "READ"
		},
		{
			icon: "ios-alert-outline",
			title: "MENU.SERVICE_REQUEST",
			page: ComplaintTabsPage,
			mod: "COM",
			type: "READ"
		}
		],
		[{
			icon: "ios-people-outline",
			title: "MENU.STAFF",
			page: MyStaffTabsPage,
			mod: "VMSSTF",
			type: "READ"
		},
		{
			icon: "ios-document-outline",
			title: "MENU.SURVEY",
			page: SurveyPage,
			mod: "SURVEY",
			type: "READ"
		},
		{
			icon: "ios-person-add-outline",
			title: "MENU.FAMILY",
			page: MembersPage,
			index: 1,
			mod: "FMB",
			type: "READ"
		},
		{
			icon: "ios-clipboard-outline",
			title: "MENU.NOTICES",
			page: NoticesPage,
			mod: "NTC",
			type: "READ"
		},
		],
		[{
			icon: "ios-body-outline",
			title: "MENU.MY_SOCIETY",
			page: MySocietyPage,
			mod: "NTC",
			type: "READ"
		},
		{
			icon: "ios-settings-outline",
			title: "MENU.SETTINGS",
			page: SettingsPage,
			mod:"STG",
			type: "READ"
		},
		{
			icon: "ios-warning-outline",
			title: "MENU.PANIC",
			page: PanicPage,
			mod: "PNC",
			type: "READ",
			bgcolor: "white",
			color: "#fd7575"
		},
		{
			icon: "ios-more",
			title: "MENU.MORE",
			page: AppSearchPage,
			mod: "URD",
			type: "READ",
			bgcolor: "white",
			color: "black"
		}
		]
	];

	quickLinks = [
		[
			// {icon: "ios-cart", title: "QUICK_LINKS.MARKET_PLACE", page: MarketPlacePage, mod : "MKTPLC", type: "READ"},
			{
				icon: "ios-create",
				title: "QUICK_LINKS.PASS",
				page: PassPurposePage,
				mod: "GNP",
				type: "READ"
			},
			{
				icon: "ios-bookmark",
				title: "QUICK_LINKS.AMENITIES",
				page: FacilitySelectLocationPage,
				mod: "FBK",
				type: "READ"
			},
			{
				icon: "ios-alert",
				title: "QUICK_LINKS.RAISE_COMPLAINTS",
				page: AddComplaintsPage,
				mod: "COM",
				type: "READ"
			},
			{
				icon: "ios-car",
				title: "BOOK_PARKING",
				page: FacilitySelectLocationPage,
				mod: "GSTPRK",
				type: "READ"
			},
			// {icon: "ios-lock", title: "Smart lock", page: SmartLockTabsPage, mod : "VEH", type: "READ"},
		]
	]

	refresh(outstanding: any) {
		outstanding.refreshing = true;
		this.bpProvider.getOutstandingBalance(outstanding.id).then(val => {
			if (val.status == "success") {
				outstanding.data.amount = val.data.amount;
			} else {
				outstanding.data = null;
				outstanding.show_bal = false;
				outstanding.message = val.message;
				this.toast.presentToast(val.message);
			}
			outstanding.refreshing = false;
		});
	}

	onMore(page: string) {
		let pages = {
			notices: NoticesPage,
			staff: MyStaffTabsPage,
			impNotice: MySocietyPage
		};
		this.navCtrl.push(pages[page]);
	}

	goTo(item: any) {

		// if(this.perPipe.transform(this.permissions, item.mod, item.type)){
		if (item.title == "MENU.PANIC" || item.title == "QUICK_LINKS.PASS") {
			let modal = this.modalCtrl.create(item.page);
			modal.present();
		}else if(item.title == "BOOK_PARKING" ){
			this.navCtrl.push(item.page, {
			type : 'PARKING'
			});
		}
		 else {
			if (item.title == "Survey") {
				localStorage.removeItem("surveyFlag");
				this.notifySurveyFlag = localStorage.getItem('surveyFlag')
			}
			let index = item.index ? item.index : 0;
			if(typeof item.page == 'string'){
				let page = null;
				switch(item.page){
					case "BillingPaymentsPage" : page = BillingPaymentsPage;break;
					case "VisitorTabsPage" : page = VisitorTabsPage;break;
					case "MeterPage" : page = MeterPage;break;
					case "ComplaintTabsPage" : page = ComplaintTabsPage;break;
					case "MyStaffTabsPage" : page = MyStaffTabsPage;break;
					case "SurveyPage" : page = SurveyPage;break;
					case "MembersPage" : page = MembersPage;break;
					case "NoticesPage" : page = NoticesPage;break;
					case "MySocietyPage" : page = MySocietyPage;break;
					case "SettingsPage" : page = SettingsPage;break;
					case "PanicPage" : page = PanicPage;break;
					case "AppSearchPage" : page = AppSearchPage;break;
					case "PassPurposePage": page =PassPurposePage;break
					case "FacilitySelectLocationPage": page =FacilitySelectLocationPage;break
					case "AddComplaintsPage": page =AddComplaintsPage;break
					case "AMENITY": page =FacilitySelectLocationPage;
						this.navCtrl.push(page, {
							type : 'AMENITY'
						}); 
						return;
					case "PARKING": page =FacilitySelectLocationPage;
						this.navCtrl.push(page, {
							type : 'PARKING'
						});
						return;
				}
				if(page){
					this.navCtrl.push(page, {
						index
					});
				}else{
					this.toast.presentToast("Service not configured. Contact Admin")
				}
			}else{
				this.navCtrl.push(item.page, {
					index
				});
			}
		}
		// }
		// else{
		//   this.toast.presentToast('Please contact your admin to enable this service.');
		// }
	}

	myVehicle() {
		this.navCtrl.push(MyVehiclePage, {
			parent: this,
		});
	}

	refreshStaff() {
		this.staffProvider.getStaffs().then(val => {
			this.staffs = [];
			try {
				if (val.status == "success") {
					for (let i = 0; i < 3 && i < val.data.length; i++) {
						this.staffs.push(val.data[i]);
					}
					// console.log(this.staffs);
				}
			} catch (error) {
				console.log(error);
			}
		});
	}

	getAmount(amount: number) {
		return Math.abs(amount);
	}

	profilePage() {
		this.navCtrl.push(ProfilePage);
	}

	panic() {
		let modal = this.modalCtrl.create(PanicPage);
		modal.present();
	}

	onNoticeClicked(notice: any, title: string) {
		this.navCtrl.push(NoticeDetailsPage, {
			notice,
			title,
		});
		if (notice.is_read == false) {
			notice.is_read = true;
			notice.set_read = true;
		}
	}

	settings() {
		this.navCtrl.push(SettingsPage);
	}

	onSearch() {
		this.navCtrl.push(AppSearchPage);
	}

	logOut() {
		this.loginProvider.logOut();
		this.navCtrl.setRoot(HomePage);
		this.menu.enable(false);
	}

	onNotifications() {
		this.navCtrl.push(NotificationsPage);
	}

	onStaffClicked(staff) {
		this.navCtrl.push(StaffDetailPage, {
			parent: this,
			data: staff
		});
	}

	makePayment(amount, billType) {

		if (this.selRegistrationLogin) {
			this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.");
		} else {
			this.navCtrl.push(MakePaymentPage, {
				amount,
				billType,
				outstanding: this.outstandings
			});
		}
	}

	getFlashNotice() {
		let text = "";
		this.flash.forEach(f => {
			if (f.notice) {
				text = text + " <b># </b>" + this.getPlainText(f.notice);
			}
		});
		return text;
	}

	showFlash(event) {
		this.util.showPopup('notification', event.srcElement.innerText);
	}

	getPlainText(content: string) {
		return content.replace(/<[^>]*>/g, '');
	}

	ionViewDidLoad() {
		// console.log("dashboard ionViewDidLoad");
		setTimeout(() => {
			this.animate = false;
		}, 10000);
		//this.intro();
	}
	checkIvrConfig() {
		this.loginProvider.getUserDetails().then(val => {
			// this.permissions = val.permissions;
			this.SettingService.getAppSettings().then(val => {
				if (!val || !('ivr_not_set_popup' in val) || (!val.ivr_not_set_popup)) {
					this.showIvrPopup();
				}
			});
		});
	}

	showIvrPopup() {
		if ((this.perPipe.transform(this.permissions, 'IVRDIS', 'READ')) || (this.perPipe.transform(this.permissions, 'IVRDIS', 'UPDATE'))) {
			return true;
		} else if ((this.perPipe.transform(this.permissions, 'PRF', 'UPDATE'))) {
			try {
				this.SettingsProvider.getUserDetails().then(val => {
					if (val && (!val.ivr_enable || !val.ivr_p)) {
						let profileModal = this.modalCtrl.create(IvrModalPage, {
							message: "IVR number is not configured. Click below to set one.",
							title: 'IVR not set'
						});
						profileModal.present();
					}
				});
			} catch (e) {
				console.log(e)
			}
		}
	}

	switchApp(appObj, type) {
		// let extras = [{"name":"token_id",	"value":"ABC12345","dataType":"String"}]
		let a = [{
			name: "token_id",
			value: "" + (this.meterUser.user.tp_token),
			dataType: "String"
		}, {
			name: "type",
			value: "" + type,
			dataType: "String"
		}];
		// console.log(a);
		this.mobileApp.openApp(appObj, a);
	}


	requestStatus() {
		this.signUpProvider.requestStatusViaLocalStorage().then(val => {
			console.log(val)
			this.registrationStatus = val.data.status
			this.adminRemarks = val.data.remarks
			console.log(this.adminRemarks)
			if (this.registrationStatus == 'APPROVED') {
				// console.log(val.data.login_details.data)
				localStorage.removeItem('signup_login')
				localStorage.removeItem('signup_user_data')
				localStorage.removeItem('signup_society')
				localStorage.removeItem('signup_token')
				localStorage.removeItem('signup_data')
				this.storage.set("loginDetails", val.data.login_details.data)
				this.navCtrl.setRoot(HomePage);
			}
			this.toast.presentToast("Your Request Status : " +val.data.status)
		})
	}
	
	openOutstandingDetails(obj){
		console.log(obj)
		let outstanding = obj.data
		let message = `
		<h3>₹ ${outstanding && outstanding.amount ?( outstanding.amount<0 ?outstanding.amount*-1 : outstanding.amount) : '-' } 
		${(outstanding) ? ((outstanding.amount>0)?'Dr':'Cr') : ''}</h3>
		<span> ${obj.message}</span>
		`;
		let outstandingStrategy = 0;
		let meterService = (outstanding && outstanding.meter_data && outstanding.meter_data.type ) ?  outstanding.meter_data.type  : "";
		let subTitle = obj.name;
		if(obj.custom_bill_config && obj.custom_bill_config.settings &&  obj.custom_bill_config.settings.outstanding_strategy){
			message +='<br><b>Strategy: </b> '
			outstandingStrategy = obj.custom_bill_config.settings.outstanding_strategy ? obj.custom_bill_config.settings.outstanding_strategy : 0
			switch(obj.custom_bill_config.settings.outstanding_strategy){
				case '1' : message +='Proactive Daily Billing';break;
				case '2' : message +='Via Metering service <b>' + meterService+'</b>';break;
				case '-1' : message +='Disabled';break;
				default: message +='Simple billing';
				outstandingStrategy = 0;
				break;
			}
		}
		// 
		if(outstanding && outstanding.bill_date){
			message +=`<br><b>Calculated on </b> ${moment(outstanding && outstanding.bill_date).format('D MMM YYYY'+( (outstanding.bill_date.split(" ").length >1)? ', hh:m A' :''))}`;
		}
		//
		if(outstandingStrategy == 2){
			message +=`
			<hr>
			<h3>Meter</h3>
			<br> <b>No </b> ${outstanding && outstanding.meter_data && outstanding.meter_data.meter && outstanding.meter_data.meter.meter_no?outstanding.meter_data.meter.meter_no : '-'}
			<br> <b>Service </b> ${outstanding && outstanding.meter_data && outstanding.meter_data.type ? outstanding.meter_data.type : '-'}
			<br> <b>Uid </b> ${outstanding && outstanding.meter_data && outstanding.meter_data.meter && outstanding.meter_data.meter.tp_uid ? outstanding.meter_data.meter.tp_uid : '-'}
			<br> <b>Site </b> ${outstanding && outstanding.meter_data && outstanding.meter_data.meter && outstanding.meter_data.meter.site && outstanding.meter_data.meter.site.site_name ? outstanding.meter_data.meter.site.site_name : '-' }
			<br> <b>Site </b> ${outstanding && outstanding.meter_data && outstanding.meter_data.meter && outstanding.meter_data.meter.site && outstanding.meter_data.meter.site.site_code ? outstanding.meter_data.meter.site.site_code : '-' }
		`
			if((!outstanding || !meterService || !outstanding.meter_data || !outstanding.meter_data.meter)){
				message += `
				<br>
				<i class="color-red"> Meter not configured properly, Kindly contact admin</i>
				`;
			}
			message +=`
			<hr><h3>Readings</h3>
			<br> <b>DG </b> ${outstanding && outstanding.meter_data ?outstanding.meter_data.dg : '-'}
			<br> <b>Grid </b> ${outstanding && outstanding.meter_data ?outstanding.meter_data.grid : '-'}
			<br> <b>Balance </b> ${outstanding && outstanding.meter_data && outstanding.meter_data.balance?outstanding.meter_data.balance : '-'}
			<br> <b>Cam Balance </b> ${outstanding && outstanding.meter_data && outstanding.meter_data.cam_balance ? outstanding.meter_data.cam_balance : '-'}
			<br> <b>${outstanding && outstanding.meter_data.cur_time ? 'Synced at ' : 'Fetched at '}</b> ${
				outstanding && outstanding.meter_data ? moment(outstanding.meter_data.date_time).format('D MMM YYYY, hh:m A') : '-'}	
			`
		}
		let alert = this.alertCtrl.create({
			title: 'Details',
			cssClass:'my-custom-class',
			subTitle :subTitle,
			message: message,
			buttons: [
			{
				text: 'Ok',
				role: 'cancel',
				handler: data => {
				console.log('Cancel clicked');
				}
			},
			
			]
		});
		alert.present();
	}
	editUserRegistration() {
		this.navCtrl.push(SignUpFormPage, {
			editForm: true
		})
	}


	getCovidList() {
		this.loginProvider.getCovidDetails().then(val =>{
			if(val){
				var newFeatureList = val.data;
				this.newCustomData = newFeatureList && newFeatureList.customData ? newFeatureList.customData.title : 'New';
				if(newFeatureList && newFeatureList.length > 0){
					newFeatureList.forEach((val) => {
						val['buttonText'] = val.buttonText ? val.buttonText : 'Click Here'  ;
						val['iconName'] = val.iconName ? val.iconName : 'assets/images/announcement.jpg';
						this.newFeatureList.push(val);
						});
				}
			}
		})
	}

	openUrl(url,location){
		console.log(url,location)
		if(location == 'page'){
			this.navCtrl.push(url, {})
		}else{
			this.loginProvider.openWithInAppBrowser(url);
		}
	}
}


// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts